import {calculatePoints as calcMultipleChoiceScore} from './MultipleChoice/calculatePoints'
import {calculatePoints as calcMultipleAnswerScore} from './MultipleAnswer/calculatePoints'
import {calculatePoints as calcLueckentextScore} from './Lueckentext/calculatePoints'
import {calculatePoints as calcFreitextScore} from './Freitext/calculatePoints'
import {calculatePoints as calcClickSvgScore} from './ClickSvg/calculatePoints'
import {calculatePoints as calcClickMatrixScore} from './ClickMatrix/calculatePoints'
import {calculatePoints as calcDnDListSortScore} from "./DnDListSort/calculatePoints"
import {calculatePoints as calcDnDGroupSortScore} from "./DnDGroupSort/calculatePoints"
import {calculatePoints as calcDnD1u1ZuordnungenScore} from "./DnD1u1Zuordnungen/calculatePoints"
import {calculatePoints as calcCTWebertest} from "./CTWebertest/calculatePoints"
import {calculatePoints as calcFrankfurterAdaptiveTest} from "./FrankfurterAdaptiveTest/calculatePoints"
import {calculatePoints as calcMilitaryReactionTest} from "./MilitaryReactionTest/calculatePoints"
import {calculatePoints as calcFlexibleReactionTest} from "./FlexibleReactionTest/calculatePoints"
import {calculatePoints as calcPersonalityTest} from "./PersonalityTest/calculatePoints"
import {calculatePoints as calcProfessionTypeTest} from "./ProfessionTypeTest/calculatePoints"
import {calculatePoints as calcNurText} from "./NurText/calculatePoints"

import * as Sentry from "@sentry/browser";

export const getPointsCalculatorFor = (question) =>
{
    if(question.isMultipleChoice())     return calcMultipleChoiceScore
    if(question.isMultipleAnswer())     return calcMultipleAnswerScore
    if(question.isLueckentext())        return calcLueckentextScore
    if(question.isFreitext())           return calcFreitextScore
    if(question.isClickSvg())           return calcClickSvgScore
    if(question.isClickMatrix())        return calcClickMatrixScore
    if(question.isDnDListSort())        return calcDnDListSortScore
    if(question.isDnDGroupSort())       return calcDnDGroupSortScore
    if(question.isDnD1u1Zuordnungen())  return calcDnD1u1ZuordnungenScore
    if(question.isCTWebertest())                return calcCTWebertest
    if(question.isFrankfurterAdaptiveTest())    return calcFrankfurterAdaptiveTest
    if(question.isMilitaryReactionTest())       return calcMilitaryReactionTest
    if(question.isFlexibleReactionTest())       return calcFlexibleReactionTest
    if(question.isPersonalityTest())       return calcPersonalityTest
    if(question.isProfessionTypeTest()) return calcProfessionTypeTest
    if(question.isNurText()) return calcNurText
}

